<template>
  <div class='section'>
    <div class='section-title'>
      <h1>방송 / 협찬</h1>
    </div>
    <div class='section-title-underline'></div>
    <div class='section-title-description'>
      <div class='section-title-description-sub'>
        <p>광고, 드라마, 영화 촬영, 브랜드 런칭쇼, 메이커 비교시승, 차량 전시 등 <br v-if='window.width < 1500'> 고객의 <br v-if='window.width > 1500'>
          다양한 목적으로 필요한 차량을 공급하는 서비스를 <br v-if='window.width < 1500'>렌트드림을 통해 이용하실 수 있습니다.</p>
      </div>
    </div>
    <div class='section-content'>
      <div class='brodcastAlbum'>
        <table v-if='window.width > 710'>
          <tr>
            <td>
              <img src='../assets/brodcast-nepa-summer.jpg'>
              <p>네파 여름 화보</p>
            </td>
            <td>
              <img src='../assets/brodcast-kt.jpg'>
              <p>KT 5G 광고 中</p>
            </td>
            <td>
              <img src='../assets/brodcast-maxim.jpg'>
              <p>커피 Maxim 광고 中</p>
            </td>
          </tr>
          <tr>
            <td>
              <img src='../assets/brodcast-inavi.jpg'>
              <p>네비게이션 아이나비 광고 中</p>
            </td>
            <td>
              <img src='../assets/brodcast-hankooktire.jpg'>
              <p>한국타이어 광고 中</p>
            </td>
            <td>
              <img src='../assets/brodcast-exo.jpg'>
              <p>엑소 ‘Call me baby’ MV 中</p>
            </td>
          </tr>
          <tr>
            <td>
              <img src='../assets/brodcast-samsung.jpg'>
              <p>삼성화재 자동차보험 광고 中</p>
            </td>
            <td>
              <img src='../assets/brodcast-jackson.jpg'>
              <p>잭슨 'Papillon' MV 中</p>
            </td>
            <td>
              <img src='../assets/brodcast-sk.jpg'>
              <p>SK 청춘편 광고 中</p>
            </td>
          </tr>
        </table>
        <table v-if='window.width < 710'>
          <tr>
            <td>
              <img src='../assets/brodcast-nepa-summer-mobile.jpg'>
              <p>네파 여름 화보</p>
            </td>
            <td>
              <img src='../assets/brodcast-maxim-mobile.jpg'>
              <p>커피 Maxim 광고 中</p>
            </td>
          </tr>
          <tr>
            <td>
              <img src='../assets/brodcast-hankooktire-mobile.jpg'>
              <p>한국타이어 광고 中</p>
            </td>
            <td>
              <img src='../assets/brodcast-inavi-mobile.jpg'>
              <p>네비게이션 아이나비 광고 中</p>
            </td>
          </tr>
          <tr>
            <td>
              <img src='../assets/brodcast-kt-mobile.jpg'>
              <p>KT 5G 광고 中</p>
            </td>
            <td>
              <img src='../assets/brodcast-exo-mobile.jpg'>
              <p>엑소 ‘Call me baby’ MV 中</p>
            </td>
          </tr>
          <tr>
            <td>
              <img src='../assets/brodcast-samsung-mobile.jpg'>
              <p>삼성화재 자동차보험 광고 中</p>
            </td>
            <td>
              <img src='../assets/brodcast-jackson-mobile.jpg'>
              <p>잭슨 'Papillon' MV 中</p>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>

</template>

<script>


export default {
  props: ['window'],
  components: {

  },
}
</script>

<style scoped>
  .section {
    background: #dddddd;
  }

  .section-content {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
  .section-title-description-sub{
    font-size: 1.28em;
  }

  .brodcastAlbum {
    margin: 5.6em;
  }
  .brodcastAlbum p {
    margin: 0;
    text-align: center;
    font-size: 2em;
  }
  .brodcastAlbum td img {
    width: 100%;
  }

  @media (max-width: 1400px){
    .brodcastAlbum p {
      font-size: 1.3em;
    }
  }
</style>
